import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const imgUrl = (u) => (!u ? "" : (u.startsWith("http") ? u : `${BACKEND_URL}${u}`));

const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "rl_token";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (window.__rlDemo && (config.url || "").startsWith("/mini/")) config.headers["X-Demo"] = "1";
  return config;
});

api.interceptors.response.use(
  (r) => {
    if (r?.data && r.data.demo === true && r.data.demo_left != null) window.dispatchEvent(new CustomEvent("rl-demo-used", { detail: r.data.demo_left }));
    if (r?.data?.practice_bonus > 0) window.dispatchEvent(new CustomEvent("rl-practice-bonus", { detail: r.data.practice_bonus }));
    return r;
  },
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 400 && typeof d === "string" && /Practice rounds finished/i.test(d)) window.dispatchEvent(new CustomEvent("rl-demo-used", { detail: 0 }));
    if (err?.response?.status === 403 && typeof d === "string" && /agent account (has been locked|has been removed|is awaiting approval)/i.test(d) && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      setTimeout(() => { window.location.href = `/auth?locked=${encodeURIComponent(d)}`; }, 50);
    }
    return Promise.reject(err);
  },
);

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
